import { cliente } from '@/lib/cliente';
import { useQuery } from '@tanstack/react-query';

export function useVendoresBC() {
  return useQuery({
    queryKey: ['bc-vendors'],
    queryFn: () => cliente.bcVendors.listar(),
    staleTime: 5 * 60 * 1000,
  });
}
